// shared/ui/DetalleEncabezado.jsx  (título + migas + acciones: WhatsApp, PDF, Editar). Presentacional.
import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import { BtnNuevo } from '../../../../nuup/componentes/Toolbar/ListToolbar.jsx';
import PillButton from './PillButton.jsx';

// sirio.css fuerza `button { color: ... !important }`, por eso los estilos llevan !important.
const whatsappDeshabilitadoSx = {
  color: '#9AA0A6 !important',
  fontWeight: 600,
  textDecoration: 'none !important',
  opacity: 0.7,
  cursor: 'not-allowed !important',
  pointerEvents: 'none',
};

const DetalleEncabezado = ({ titulo, migas, editPath, onDescargarPdf, descargandoPdf = false }) => (
  <div className="d-flex justify-content-between align-items-start flex-wrap mb-3" style={{ gap: 12 }}>
    <div>
      <h1 className="page-header mb-1">{titulo}</h1>
      <div style={{ color: '#8a8f98', fontSize: 13 }}>{migas}</div>
    </div>
    <div className="d-flex align-items-center flex-wrap" style={{ gap: 14 }}>
      {/* TODO(whatsapp): habilitar cuando exista el endpoint de envío (POST at/{capacitaciones|visitas}/{uuid}/whatsapp). */}
      <span title="Disponible próximamente" style={{ cursor: 'not-allowed' }}>
        <Box component="button" type="button" className="btn btn-link p-0" disabled aria-disabled="true" sx={whatsappDeshabilitadoSx}>
          <i className="fab fa-whatsapp pr-2" />
          Compartir por WhatsApp
        </Box>
      </span>
      <PillButton icon={descargandoPdf ? null : 'fa-file-pdf'} onClick={onDescargarPdf} disabled={descargandoPdf}>
        {descargandoPdf && <CircularProgress size={14} color="inherit" className="mr-2" />}
        {descargandoPdf ? 'Generando PDF…' : 'Descargar PDF'}
      </PillButton>
      <BtnNuevo to={editPath} icon="fa-pen">
        Editar
      </BtnNuevo>
    </div>
  </div>
);

export default DetalleEncabezado;
